import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Grid, GridItem } from '@chakra-ui/react'
import MyDiv from './investmentDeclarationDetail.style';
import DeclarationProfile from '../components/DeclarationProfile';
import * as routesNames from '../../../constants/routes'
import { NewInvestmentTaxRegime, OldInvestmentTaxRegime } from '../components';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

const InvestmentDeclarationDetail = () => {
    const location = useLocation();
    const { employee } = location.state || {};
    // console.log('object',employee)
    const [isLoading, setIsLoading] = useState(false);
    const [showAcceptedDetails, setShowAcceptedDetails] = useState(false);
    const [showRejectedDetails, setShowRejectedDetails] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertStatus, setAlertStatus] = useState<'Accept' | 'Reject' | null>(null);

    const handleConfirmStatusChange = () => {
        setAlertOpen(false);
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            if (alertStatus === 'Accept') {
                setShowAcceptedDetails(true);
                setShowRejectedDetails(false);
            } else {
                setShowRejectedDetails(true);
                setShowAcceptedDetails(false);
            }
        }, 3000);
    };


  return (
    <MyDiv>
      <Breadcrumb spacing='5px' className="font_poppins text_md text_medium" separator=">>">
        <BreadcrumbItem>
          <BreadcrumbLink className="font_poppins text_md text_medium" color="gray.500" href={routesNames.TAXDECLARATION}>Investment Declaration</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink className="font_poppins text_md text_medium" href="#">Employee Tax Declaration Details</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Grid className='grid_container'>
        <GridItem colSpan={4}>
          <Box  className='tab-list-container' mt={4}>
            <DeclarationProfile />
          </Box>
        </GridItem>
        <GridItem colSpan={8} pl={4} >
          {employee.taxRegime === 'Old Tax Regime' ?
           <OldInvestmentTaxRegime 
           isLoading={isLoading}
           setIsLoading = {setIsLoading}
           showAcceptedDetails={showAcceptedDetails}
           showRejectedDetails={showRejectedDetails}
           alertOpen={alertOpen}
           alertStatus={alertStatus}
           setAlertOpen={setAlertOpen}
           setAlertStatus={setAlertStatus}
           onConfirmStatusChange={handleConfirmStatusChange}
           />
            : 
            <NewInvestmentTaxRegime 
           isLoading={isLoading}
           setIsLoading = {setIsLoading}
           showAcceptedDetails={showAcceptedDetails}
           showRejectedDetails={showRejectedDetails}
           alertOpen={alertOpen}
           alertStatus={alertStatus}
           setAlertOpen={setAlertOpen}
           setAlertStatus={setAlertStatus}
           onConfirmStatusChange={handleConfirmStatusChange}
           />
           }
        </GridItem>
      </Grid>
    </MyDiv>
  )
}

export default InvestmentDeclarationDetail;
